import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 55 — "how to hire a GoHighLevel expert" process cluster service links.
 *
 * Every Batch 55 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch55Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH55_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "how-to-hire-a-gohighlevel-expert": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /marketplace freelancer who builds one workflow is not a dedicated architect who designs the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "how-to-vet-a-gohighlevel-specialist": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /marketplace freelancer who lists GoHighLevel is not a vetted specialist who can architect/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-expert-interview-questions": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /candidate who can recite the features is not a specialist who can architect the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "how-to-write-a-gohighlevel-expert-job-description": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /job post that lists the tasks is not a scope that signals a real architect/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
